// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video[data-v-29b851e7]{width:100%;height:239px !important}.video video[data-v-29b851e7]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
